import { render, staticRenderFns } from "./CustomNodeProperties.vue?vue&type=template&id=8529bd78&scoped=true"
import script from "./CustomNodeProperties.vue?vue&type=script&lang=js"
export * from "./CustomNodeProperties.vue?vue&type=script&lang=js"
import style0 from "./CustomNodeProperties.vue?vue&type=style&index=0&id=8529bd78&prod&scoped=true&lang=scss"
import style1 from "./CustomNodeProperties.vue?vue&type=style&index=1&id=8529bd78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8529bd78",
  null
  
)

export default component.exports